import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router';
import {preventLinkScroll} from 'utils/commonUtils';
import {isLinkActive} from 'utils/routeUtils';

@withRouter
export default class SwitchBtns extends Component {
  static propTypes = {
    buttons: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.string,
      onSelect: PropTypes.func,

      href: PropTypes.string,
      text: PropTypes.string.isRequired
    })).isRequired,

    value: PropTypes.any,
    onChange: PropTypes.func,

    router: PropTypes.object,
    className: PropTypes.string,
    activeOptionClassName: PropTypes.string,
    buttonCount: PropTypes.string
  }

  constructor(props, ...args) {
    super(props, ...args);

    this.state = {
      value: props.value
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.value != this.props.value) {
      this.setState({
        value: newProps.value
      });
    }
  }

  render() {
    const {
      buttons = [],
      activeOptionClassName = "tab-selected",
      className = "switch-buttons",
      buttonCount = buttons.length,
      onChange,
      router
    } = this.props;

    const {
      value: controlValue
    } = this.state;

    const buttonLink = button => {
      const {
        href,
        text,
        value = href,
        onSelect
      } = button;

      const props = {};
      let link;

      if (onChange || onSelect) {
        props.onClick = event => {
          const eventData = [event, {href, text, value}];

          if (onChange) {
            onChange(...eventData);
          }

          if (onSelect) {
            onSelect(...eventData);
          }
        }
      }

      if (href) {
        if (isLinkActive(router, button)) {
          props.className = activeOptionClassName;
        }

        props.to = preventLinkScroll(href);

        link = <Link {...props}>{text}</Link>;
      }
      else {
        if (button.value == controlValue) {
          props.className = activeOptionClassName;
        }

        link = <span {...props}>{text}</span>;
      }

      return <li key={value} className={`button-count-${buttonCount}`}>{link}</li>
    };

    return (
      <nav className={className}>
        <ul>
          {buttons.map(buttonLink)}
        </ul>
      </nav>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Common/components/SwitchBtns.js